import { Component, OnInit, ViewChild, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import { FormControl } from '@angular/forms';
import { LeadService } from 'src/app/pages/lead/services/lead.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { WidgetService } from 'src/app/widgets/services/widget.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'advfilter',
    templateUrl: './advancefilter.component.html',
    styleUrls: ['./advancefilter.component.scss'],
    standalone: false
})
export class AdvancefilterComponent implements OnInit, OnDestroy {
  itemCount = 10;
  globalSearchText: any = '';
  sortField: any = 'created_at';
  sortOrder: any = 'DESC';
  where: any;
  savefiltercolor: any;
  userMerchants: any;
  sliderValue: number = 0;
  sliderMaxValue: number = 0;
  selectable = true;
  removable = true;
  allOrgArr:any;
  searchTags: string = '';
  private _unsubscribeAll: Subject<any> = new Subject();
  sliderOptions: Options = {
    floor: 0,
    ceil: 100000,
    step:250,
    translate: (value: number, label: LabelType): string => {
      //this.savedFilter.slider_value = this.sliderValue + '-' + this.sliderMaxValue;
      switch (label) {
        case LabelType.Low:
          return this.getCurrency() + ' ' + new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value);
        case LabelType.High:
          return this.getCurrency() + ' ' + new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value);
        default:
          return this.getCurrency() + ' ' + new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value);
      }
    }
  };
  savedFilter: any = {};
  singale_value = new FormControl();
  deal_typeArr: any[] = [];
  deal_stageArr: any[] = [];
  activityArr: any[] = [];
  @Input() tagsArr: any[] = [];
  @Input() allTagsArr: any[] = [];
  @Input() customerCustomFieldArr: any[] = [];
  @Input() dealCustomFieldArr: any[] = [];
  @Input() compactMode = false;
  stageDummyArr: any[] = [];
  activityDummyArr: any[] = [];
  orgDummyArr: any[] = [];
  tagsDummyArr: any[] = [];
  customFieldDummyArr: any[] = [];
  dealcustomFieldDummyArr: any[] = [];
  viewData: any;
  totalCount: number;
  @ViewChild(MatMenuTrigger, { static: false }) matMenuTrigger: MatMenuTrigger;
  deactivatedleads: any;
  rotted_days: any;
  deal_status: any;

  constructor(
    public leadService: LeadService,
    public WidgetService: WidgetService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    if(localStorage.getItem('leadFilters')) {
      this.savedFilter = JSON.parse(localStorage.getItem('leadFilters'));
      if(this.savedFilter?.deal_type) {
        this.getDealStage(this.savedFilter?.deal_type[0]?.id);
      }
      if(this.savedFilter?.customFields) {
        this.customFieldDummyArr = this.savedFilter?.customFields;        
      }

      if(this.savedFilter?.dealcustomFields) {
        this.dealcustomFieldDummyArr = this.savedFilter?.dealcustomFields;        
      }
    }    
    this.getViews();
    this.getOrgList()
    this.userMerchants = JSON.parse(localStorage.getItem('user_merchants'));
    this.leadService.activeTabs$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => { this.deal_status = res; });
  }

  getCurrency() { return this.userMerchants[0]?.merchant_details?.currencies?.currency_symbol || '' }

  getAccorValue(event: any, value: any, from: any) {
    if (from === 'organization') {
      if (event?.checked) {
        this.orgDummyArr.push({ id: value?.id, name: value?.name });
        this.savedFilter['organization'] = this.orgDummyArr;
      } else {
        this.orgDummyArr?.splice(this.orgDummyArr?.findIndex((obj) => obj?.id === value?.id), 1);
        this.savedFilter['organization'] = this.orgDummyArr;
      }   
     }

    if (from === 'deal_type') {
      this.getDealStage(value?.id);
      this.savedFilter['deal_type'] = [{ id: value?.id, name: value?.name }];
    }

    if (from === 'deal_stage') {
      if (event?.checked) {
        this.stageDummyArr.push({ id: value?.id, name: value?.name });
        this.savedFilter['deal_stage'] = this.stageDummyArr;
      } else {
        this.stageDummyArr?.splice(this.stageDummyArr?.findIndex((obj) => obj?.id === value?.id), 1);
        this.savedFilter['deal_stage'] = this.stageDummyArr;
      }
    }

    if (from === 'activity') {
      if (event?.checked) {
        this.activityDummyArr.push({ id: value?.id, name: value?.name });
        this.savedFilter['activity'] = this.activityDummyArr;
      } else {
        this.activityDummyArr?.splice(this.activityDummyArr?.findIndex((obj) => obj?.id === value?.id), 1);
        this.savedFilter['activity'] = this.activityDummyArr;
      }
    }

    if (from === 'tags') {
      this.leadService.getTagsList().pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
        if (res.data.length) {
          const tagExists = this.tagsDummyArr.some(tag => tag.id === value?.id);
    
          if (event?.checked && !tagExists) {
            this.tagsDummyArr.push({ id: value?.id, name: value?.name });
            this.savedFilter['tags'] = this.tagsDummyArr;
          } else if (!event?.checked && tagExists) {
            this.tagsDummyArr.splice(this.tagsDummyArr.findIndex(obj => obj?.id === value?.id), 1);
            this.savedFilter['tags'] = this.tagsDummyArr;
          }
        }
      });
    }

    if (from === 'customFields') {      
      if (event?.checked) {
        this.customFieldDummyArr.push({ id: value?.id, name: value?.name });
        this.savedFilter['customFields'] = this.customFieldDummyArr;
      } else {        
        this.customFieldDummyArr?.splice(this.customFieldDummyArr?.findIndex((obj) => obj?.id+'--'+obj?.name === value?.id+'--'+value?.name), 1);
        console.log(this.customFieldDummyArr)
        this.savedFilter['customFields'] = this.customFieldDummyArr;
      }
    }

    if (from === 'dealcustomFields') {      
      if (event?.checked) {
        this.dealcustomFieldDummyArr.push({ id: value?.id, name: value?.name });
        this.savedFilter['dealcustomFields'] = this.dealcustomFieldDummyArr;
      } else {        
        this.dealcustomFieldDummyArr?.splice(this.dealcustomFieldDummyArr?.findIndex((obj) => obj?.id+'--'+obj?.name === value?.id+'--'+value?.name), 1);
        console.log(this.dealcustomFieldDummyArr)
        this.savedFilter['dealcustomFields'] = this.dealcustomFieldDummyArr;
      }
    }

    if (from === 'singale_value') {
      this.savedFilter['singale_value'] = value;
      this.sliderValue = 0;
      this.sliderMaxValue = 0;
      this.savedFilter.slider_value = null;
    }

    if (from === 'slider_value') {
      this.savedFilter['slider_value'] = (this.sliderValue && this.sliderMaxValue) ? this.sliderValue + '-' + this.sliderMaxValue : null;
      if (event || value) {
        this.singale_value.setValue(null);
        this.savedFilter.singale_value = '';
      }
    }

    if (from === 'singale_date') {
      this.savedFilter['singale_date'] = event;
      this.savedFilter.start_date = null;
      this.savedFilter.end_date = null;
      this.savedFilter.from_to_date = null;

    }

    if (value === 'fromtodate') {
      if (from === 'start_date') {
        this.savedFilter['start_date'] = event;
        this.savedFilter.singale_date = null;
      }
      if (from === 'end_date') {
        this.savedFilter['end_date'] = event;
        this.savedFilter.singale_date = null;
      }
      this.savedFilter['from_to_date'] = (this.savedFilter?.end_date != null && this.savedFilter?.start_date != null) ? (this.savedFilter?.start_date + ' to ' + this.savedFilter?.end_date) : null;
    }

    if (from === 'rotten_days') {
      this.savedFilter['show_rotten_deals'] = this.rotted_days ? this.rotted_days : 0;
    }
    if (from === 'in_active_deals') {
      this.savedFilter['show_deactivated_leads'] = this.deactivatedleads ? this.deactivatedleads : 0;
    }
    
  }

  removeFilter(id, type) {
    if (type === 'deal_type') {
      this.savedFilter?.deal_type?.splice(this.savedFilter?.deal_type?.findIndex((obj) => obj?.id === id), 1);
    }
    if (type === 'deal_stage') {
      this.savedFilter?.deal_stage?.splice(this.savedFilter?.deal_stage?.findIndex((obj) => obj?.id === id), 1);
    }
    if (type === 'activity') {
      this.savedFilter?.activity?.splice(this.savedFilter?.activity?.findIndex((obj) => obj?.id === id), 1);
    }
    if (type === 'organization') {
      this.savedFilter?.organization?.splice(this.savedFilter?.organization?.findIndex((obj) => obj?.id === id), 1);
    }
    if (type === 'tags') {
      this.savedFilter?.tags?.splice(this.savedFilter?.tags?.findIndex((obj) => obj?.id === id), 1);
      this.tagsArr = this.tagsArr.map(e => (e.id === id ? { ...e, checked: false } : e));
    }
    if (type === 'customFields') {
      this.savedFilter?.customFields?.splice(this.savedFilter?.customFields?.findIndex((obj) => obj?.id === id), 1);
      this.customerCustomFieldArr = this.customerCustomFieldArr.map(e => (e.id === id ? { ...e, checked: false } : e));
    }
        if (type === 'dealcustomFields') {
      this.savedFilter?.dealcustomFields?.splice(this.savedFilter?.dealcustomFields?.findIndex((obj) => obj?.id === id), 1);
      this.dealCustomFieldArr = this.dealCustomFieldArr.map(e => (e.id === id ? { ...e, checked: false } : e));
    }
    if (type === 'singale_value') {
      this.savedFilter.singale_value = '';
      this.singale_value?.setValue(null);
    }
    if (type === 'slider_value') {
      this.sliderValue = 0;
      this.sliderMaxValue = 0;
      this.savedFilter.slider_value = null;
    }
    if (type === 'singale_date') {
      this.savedFilter.singale_date = null;
    }
    if (type === 'from_to_date') {
      this.savedFilter.from_to_date = null;
      this.savedFilter.end_date = null;
      this.savedFilter.start_date = null;
    }
    this.deactivatedleads = 0;
    this.rotted_days = 0;
  }

  toggle(event: any, type: string) {
    if (type === 'rotten_days') {
      this.rotted_days = event?.checked ? 1 : 0;
      this.leadService.rotted_days$.next(this.rotted_days);
      this.getAccorValue('', '', 'rotten_days');
    }

    if (type === 'in_active_deals') {
      this.deactivatedleads = event?.checked ? 1 : 0;
      this.leadService.deactivatedStatus$.next(this.deactivatedleads);
      this.getAccorValue('', '', 'in_active_deals');
    }

  }

  saveFilter() {
    let payload = {
      pagination: true,
      limit: this.itemCount,
      page: 1,
      search: this.globalSearchText ? this.globalSearchText : '',
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      whereFilterData: [{
        deal_status: "",
        activity_id: [],
        deal_type_id: [],
        deal_stage_id: [],
        organization_id:[],
        tag_id: [],
        customField: [],
        customFieldIds: [],
        dealcustomField: [],
        dealcustomFieldIds: [],
        show_deactivated_leads: this.deactivatedleads ? this.deactivatedleads : 0,
        show_rotten_deals: this.rotted_days ? this.rotted_days : 0
      }]
    }

    if (this.savedFilter) {

      if (this.savedFilter?.activity) {
        this.savedFilter?.activity?.forEach((ac, i) => {
          payload.whereFilterData[0]['activity_id']?.push(ac?.id)
        })
      };

      if (this.savedFilter?.organization) {
        this.savedFilter?.organization?.forEach((ac, i) => {
          payload.whereFilterData[0]['organization_id']?.push(ac?.id)
        })
      };

      if (this.savedFilter?.tags) {
        let identicalTagsFilter = [];
        this.savedFilter.tags.forEach(savedTag => {
          let filteredArray = this.allTagsArr
            .filter(tag => tag.name === savedTag.name)
            .map(tag => ({ name: tag.name, id: tag.id }));
          
          identicalTagsFilter = identicalTagsFilter.concat(filteredArray);
        });
        console.log(identicalTagsFilter);
        identicalTagsFilter.forEach((ac, i) => {
          if(!payload.whereFilterData[0]['tag_id'].includes(ac?.id)){
            payload.whereFilterData[0]['tag_id']?.push(ac?.id)
          }
        })
      };
      if (this.savedFilter?.customFields) {
        this.savedFilter.customFields.forEach((ac, i) => {
          const id = ac?.id;
          const value = ac?.name;
          if (!payload.whereFilterData[0]['customFieldIds'].includes(id)) {
            payload.whereFilterData[0]['customFieldIds'].push(id);
            payload.whereFilterData[0]['customField'].push({id: id, value: value});
          }
        });
      };

      if (this.savedFilter?.dealcustomFields) {
        this.savedFilter.dealcustomFields.forEach((ac, i) => {
          const id = ac?.id;
          const value = ac?.name;
          if (!payload.whereFilterData[0]['dealcustomFieldIds'].includes(id)) {
            payload.whereFilterData[0]['dealcustomFieldIds'].push(id);
            payload.whereFilterData[0]['dealcustomField'].push({id: id, value: value});
          }
        });
      };

      if (this.savedFilter?.deal_type) {
        this.savedFilter?.deal_type?.forEach((ac, i) => {
          payload.whereFilterData[0]['deal_type_id']?.push(ac?.id)
        })
      };
      if (this.savedFilter?.deal_stage) {
        this.savedFilter?.deal_stage?.forEach((ac, i) => {
          payload.whereFilterData[0]['deal_stage_id'].push(ac?.id)
        })
      };
      if (this.savedFilter?.singale_value) {
        payload.whereFilterData[0]['single_value'] = this.savedFilter?.singale_value;
      };

      if (this.sliderValue) {
        payload.whereFilterData[0]['min_value'] = this.sliderValue;
      };
      if (this.sliderMaxValue) {
        payload.whereFilterData[0]['max_value'] = this.sliderMaxValue;
      };
      if (this.savedFilter?.singale_date) {
        payload.whereFilterData[0]['singale_date'] = this.savedFilter?.singale_date;
      };

      if (this.savedFilter?.start_date) {
        payload.whereFilterData[0]['start_date'] = this.savedFilter?.start_date;
      };
      if (this.savedFilter?.end_date) {
        payload.whereFilterData[0]['end_date'] = this.savedFilter?.end_date;
      };
    }
    payload.whereFilterData[0]['show_deactivated_leads'] = this.deactivatedleads ? this.deactivatedleads : 0;
    payload.whereFilterData[0]['show_rotten_deals'] = this.rotted_days ? this.rotted_days : 0;
    payload.whereFilterData[0]['deal_status'] = this.deal_status;
    payload.whereFilterData = [this.clean(payload?.whereFilterData[0])];
  // Extract and remove tag_id from payload.whereFilterData
let tagIds: string[] | null = null;

if (payload.whereFilterData?.length) {
  payload.whereFilterData.forEach(obj => {
    if (obj.tag_id) {
      payload.limit = 100;          // add limit if tag is present
      tagIds = obj.tag_id;          // store the tag_id value
      delete obj.tag_id;            // remove tag_id from the object
    }
  });
}

console.log('Updated payload:', payload.whereFilterData);
console.log('Stored tagIds:', tagIds);

// Save filters in localStorage
localStorage.setItem('leadAppliedFilter', JSON.stringify(payload.whereFilterData));
localStorage.setItem('leadFilters', JSON.stringify(this.savedFilter));

console.log(this.viewData, 'this.viewData');

if (this.viewData === 'list_view') {
  this.leadService.getLeadList(payload).pipe(takeUntil(this._unsubscribeAll)).subscribe(
    (val: any) => {
      if (val) {
        let filteredResponse = val;

        if (tagIds?.length) {
          // Filter data based on tagIds
          const filteredData = val.data.filter(item => {
            const customerTags = item.merchantCustomerLeadTags?.map(t => t.id) || [];
            const dealTags = item.merchantCustomerDeal?.flatMap(deal => 
              deal.merchantLeadDealTags?.map(t => t.id) || []
            ) || [];

            return tagIds.some(tagId => customerTags.includes(tagId) || dealTags.includes(tagId));
          });

          // Prepare filtered response
          filteredResponse = {
            ...val,
            data: filteredData,
            totalCount: filteredData.length,
            pageDetail: filteredData.length === 0 ? '0 - 0 of 0' : `1 - ${Math.min(10, filteredData.length)} of ${filteredData.length}`,
            totalPages: 1,
            currentPage: 1
          };
        }

        this.leadService.resetFilterleadValue$.next({ filterWhere: this.savedFilter, view: 'list_view' });
        this.leadService.tableDataSource$.next(filteredResponse);
        this.leadService.cardLayoutViewData$.next(null);        
        this.leadService.totalLeadCount$.next({totalCount:filteredResponse?.data?.length})

    // Restore tag_id back into payload.whereFilterData after filtering
if (tagIds?.length && payload.whereFilterData?.length) {
  payload.whereFilterData.forEach(obj => {
    obj.tag_id = tagIds;
  });

  // Save updated payload in localStorage
  localStorage.setItem('leadAppliedFilter', JSON.stringify(payload.whereFilterData));
}
        
const existingFilters = JSON.parse(localStorage.getItem('leadAppliedFilter') || '[]');
console.log(existingFilters,'existingFiltersexistingFiltersexistingFilters');


        this.savedFilter = {};
        this.singale_value.setValue(null);
        this.leadService.closeFilter$.next(true);
      }
    },
    (error) => {
      console.error('Error fetching lead list:', error);
    }
  );
}



if (this.viewData === 'grid_view') {
  this.leadService.resetFilterleadValue$.next({ filterWhere: this.savedFilter, view: 'grid_view' });
  this.leadService.cardLayoutViewData$.next(payload?.whereFilterData);

  // Reset filters and sliders
  this.savedFilter = {};
  this.singale_value.setValue(null);
  this.deactivatedleads = 0;
  this.rotted_days = 0;
  this.sliderValue = 0;
  this.sliderMaxValue = 0;
  this.savedFilter.slider_value = null;
  this.leadService.closeFilter$.next(true);
}

  }
  
  clean(obj) {
    for (let propName in obj) {
      if (obj[propName]?.length === 0) {
        delete obj[propName];

      }
    }
    return obj
  }

  resetFilter() {
    localStorage.removeItem('leadFilters');

    if (this.viewData === 'list_view') {
      this.matMenuTrigger?.closeMenu();
      this.savedFilter = {}; this.singale_value.setValue(null);
      this.leadService.cardLayoutViewData$.next(null);
      this.leadService.resetFilterleadValue$.next({ resetFromFilterLead: true, view:'list_view' });
      this.leadService.closeFilter$.next(true);
    }

    if (this.viewData === 'grid_view') {
      this.matMenuTrigger?.closeMenu();
      this.leadService.cardLayoutViewData$.next(null);
      this.leadService.resetFilterleadValue$.next({ resetFromFilterLead: true, view:'grid_view' });
      this.savedFilter = {};
      this.singale_value.setValue(null);
      this.deactivatedleads = 0;
      this.rotted_days = 0;
      this.sliderValue = 0;
      this.sliderMaxValue = 0;
      this.savedFilter.slider_value = null;
      this.leadService.closeFilter$.next(true);
    }

  }

  getActivityList() {
    this.leadService.leadNoteActivity().pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
      this.activityArr = res ? res?.data : null;
      this.leadService.lead_Activity_List$.next(res);
    }, (error) => { });
  }

  getTags() {
    this.leadService.getTagsList().pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
      this.tagsArr = res ? this.getUniqueTags(res.data, 'name') : null;
      this.allTagsArr =  res?.data;
    }, (error) => { });

  }

  getOrgList(){
    this.leadService.getOrganizationList().pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
      // this.tagsArr = res ? this.getUniqueTags(res.data, 'name') : null;
      this.allOrgArr =  res?.data;
    }, (error) => { });

  }

  getUniqueTags(tags: any[], property: string): any[] {
    return Array.from(new Set(tags.map(tag => tag[property]))).map(name => {
      return tags.find(tag => tag[property] === name);
    });
  }

  getDealType() {
    this.leadService.getDealTypeList().pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
      this.WidgetService.dealType_List$.next(res);
      this.deal_typeArr = res ? res?.data : null;
      this.getActivityList();
      this.getTags();
    }, (error) => { });
  }

  getDealStage(id: any) {
    this.leadService.dealStageList({ deal_type_id: id }).pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
      this.deal_stageArr = res?.data ? res?.data : null;
    })
  }

  getOrgDetail(id: any) {
    console.log(id,'kkkkkkkkkkkkkkkk')
    // this.leadService.dealStageList({ deal_type_id: id }).subscribe((res: any) => {
    //   this.deal_stageArr = res?.data ? res?.data : null;
    // })
  }

  getViews() {
    this.leadService.viewFilter$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
      if (res) {
        this.viewData = res;
        if (res === 'list_view') { this.getDealType(); }
        if (res === 'grid_view') { this.getActivityList(); this.getTags(); }
      }
    })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }

  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }


  checkValueExist(item_arr, item) {
    let findIndex = item_arr?.findIndex((obj) => obj?.id === item);    
    return findIndex >= 0;
  }
  checkValueExistWithId(item_arr, item) {
    let findIndex = item_arr?.findIndex((obj) => obj?.id + '--' + obj.name === item);    
    return findIndex >= 0;
  }
  
}
